import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { t } from 'i18next'
import { colors } from '../../../styles/colors'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { formatedDate } from '../../../utils/formatedDate'
import InformationPopover from '../../InformationPopover/InformationPopover'
import MediaQuery from 'react-responsive'
import { StyledValidationMessage } from './formHelper'

const StyledBatchKey = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const WarrantyDateView = ({ id, warrantyDate, disabled = false, handleOnChange, formError }) => {

    return (
        <div className="mb-3">
            <Form.Group className="mb-3">
                <Form.Label >{t('createLocalInventory:warrantyDate')}</Form.Label><MediaQuery minWidth={550}><InformationPopover header={t('createLocalInventory:warrantyDate')} content={t('createLocalInventory:warrantyDateInfo')} /></MediaQuery>
                {!disabled ?
                    <>
                        <CustomDatePicker
                            id={id}
                            name="warrantyDate"
                            dateFormat="dd.MM.yyyy"
                            placeholderText={t('date')}
                            onChange={handleOnChange('warrantyDate')}
                            showYearDropdown
                            selected={warrantyDate}
                            isInvalid={!!formError}
                        />
                        {!!formError &&
                            <StyledValidationMessage>{formError}</StyledValidationMessage>
                        }
                    </>
                    : formatedDate(warrantyDate) ? <StyledBatchKey>{formatedDate(warrantyDate)}</StyledBatchKey> : null
                }
            </Form.Group>
        </div>

    )
}
export default WarrantyDateView